import SEO from "../../components/SEO";
export const TermsPage = () => {
	return (
		<div className="w-full min-h-screen bg-gradient-to-br from-cyan-100 to-fuchsia-200 py-12 px-5"><SEO title="Terms of Service" description="Parcelin terms of service. Read our terms for parcel delivery, prohibited items, pricing, cancellation and liability policies." path="/terms" />
			<div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-8 md:p-12">
				<h1 className="text-4xl font-bold text-purple-800 mb-6">Terms of Service</h1>
				<p className="text-gray-600 mb-8">Last Updated: November 2024</p>

				<div className="space-y-8 text-gray-700">
					<section>
						<h2 className="text-2xl font-bold text-purple-800 mb-4">1. Acceptance of Terms</h2>
						<p className="mb-4">
							By accessing and using Parcelin's services, you accept and agree to be bound by the terms and provision of this agreement. 
							If you do not agree to these terms, please do not use our services.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-purple-800 mb-4">2. Service Description</h2>
						<p className="mb-4">
							Parcelin provides a platform connecting senders with verified drivers for parcel delivery services. We facilitate long-distance 
							parcel delivery by utilizing vehicles already traveling between locations.
						</p>
						<p className="mb-4">
							Our services include:
						</p>
						<ul className="list-disc pl-6 space-y-2">
							<li>Same-day and next-day parcel delivery</li>
							<li>Real-time parcel tracking</li>
							<li>Secure payment processing</li>
							<li>Basic parcel insurance</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-purple-800 mb-4">3. User Responsibilities</h2>
						<p className="mb-4">As a user of Parcelin, you agree to:</p>
						<ul className="list-disc pl-6 space-y-2">
							<li>Provide accurate and complete information when booking deliveries</li>
							<li>Ensure parcels are properly packaged and labeled</li>
							<li>Not send prohibited or illegal items</li>
							<li>Be available at the specified pickup time</li>
							<li>Pay all applicable fees for services rendered</li>
							<li>Maintain the confidentiality of your account credentials</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-purple-800 mb-4">4. Prohibited Items</h2>
						<p className="mb-4">The following items are strictly prohibited from being sent through Parcelin:</p>
						<ul className="list-disc pl-6 space-y-2">
							<li>Illegal substances or contraband</li>
							<li>Weapons, firearms, or explosives</li>
							<li>Hazardous materials or chemicals</li>
							<li>Perishable food items (unless properly packaged)</li>
							<li>Live animals</li>
							<li>Stolen goods or counterfeit items</li>
							<li>Items that violate South African law</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-purple-800 mb-4">5. Pricing and Payment</h2>
						<p className="mb-4">
							Pricing is determined based on distance, parcel size, and delivery speed. All prices are displayed in South African Rand (ZAR) 
							and are inclusive of VAT where applicable.
						</p>
						<p className="mb-4">
							Payment must be made at the time of booking through our accepted payment methods. Refunds are subject to our cancellation policy.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-purple-800 mb-4">6. Cancellation and Refunds</h2>
						<p className="mb-4">
							Cancellations made before driver pickup may be eligible for a full or partial refund. Cancellations made after pickup 
							are not eligible for refunds. Specific cancellation fees apply based on timing.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-purple-800 mb-4">7. Liability and Insurance</h2>
						<p className="mb-4">
							All parcels are covered by basic insurance up to a specified value. Parcelin is not liable for:
						</p>
						<ul className="list-disc pl-6 space-y-2">
							<li>Damage resulting from improper packaging</li>
							<li>Loss or damage of prohibited items</li>
							<li>Delays caused by circumstances beyond our control</li>
							<li>Indirect or consequential damages</li>
						</ul>
						<p className="mt-4">
							Additional insurance is available for high-value items at the time of booking.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-purple-800 mb-4">8. Driver Verification</h2>
						<p className="mb-4">
							All Parcelin drivers undergo verification including license checks and vehicle registration verification. However, 
							Parcelin acts as a platform connecting senders and drivers and is not directly responsible for driver actions.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-purple-800 mb-4">9. Privacy and Data Protection</h2>
						<p className="mb-4">
							Your privacy is important to us. Please refer to our Privacy Policy for information on how we collect, use, and protect your data 
							in compliance with South African data protection laws.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-purple-800 mb-4">10. Dispute Resolution</h2>
						<p className="mb-4">
							Any disputes arising from the use of Parcelin services will be resolved through good faith negotiation. If resolution cannot be reached, 
							disputes will be subject to the jurisdiction of South African courts.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-purple-800 mb-4">11. Changes to Terms</h2>
						<p className="mb-4">
							Parcelin reserves the right to modify these terms at any time. Users will be notified of significant changes via email or 
							through the platform. Continued use of services after changes constitutes acceptance of modified terms.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-purple-800 mb-4">12. Contact Information</h2>
						<p className="mb-4">
							For questions about these Terms of Service, please contact us at:
						</p>
						<p className="mb-2">Email: support@parcelin.co.za</p>
						<p className="mb-2">Phone: 069 904 2846</p>
					</section>
				</div>

				<div className="mt-12 pt-8 border-t border-gray-200 text-center">
					<p className="text-gray-600">
						By using Parcelin, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
					</p>
				</div>
			</div>
		</div>
	);
};
